import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

const EnrollmentSuccess = (props) => {
        
    const enrollmentStore = useSelector((state: any) => state.enrollmentForm);
    
    useEffect(() => {
    
        return () => {

        }
    },[]);

    return (
        <>
        <div className="content mb-3">
            <h6 className="grey_wrapper_title"><i className="fas fa-camera-retro"/> &nbsp; Enrollment Confirmation - First Class Learning </h6>
            <div className="">
                <p className="text-justify">Thank you for enrolling your child at First Class Learning.</p>
                <p className="text-justify">We have received your submission and will process the enrolment shortly. You will receive a confirmation email with copy of the information provided on this form and full terms and conditions. </p>
                <p className="text-justify">
                    What's next? <br/>
                    For setting up a Standing Order please find the account details below -<br/>
                    <b>Sort Code:</b> {enrollmentStore?.formData?.franchise_sort_code || '---'} <br/>
                    <b>Account Number:</b> {enrollmentStore?.formData?.franchise_account_number || '---'} <br/>
                </p>
                <p className="text-justify">If you have any urgent questions, feel free to contact us at <b>{enrollmentStore?.formData?.frnachise_phone || '---'}</b>. We look forward to supporting your child on their learning journey!</p>
                <p className="text-justify">
                    <b>Best Regards</b> <br/> 
                    {enrollmentStore?.formData?.franchise_user_name || '---'} <br/>
                    Franchise Owner
                </p>
            </div>
        </div>
        <div className="mx-4">
            <Link className="btn btn-default float-right" to="/" > Back To Dashboard </Link>
        </div>
        </>
    );
};

export default EnrollmentSuccess;